import { get, post } from '@/service/request';
import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/cloudECounter';

const loanUrl = `${url}/policyLoan`;

export function initTransaction(aplCatl) {
    return post(`${url}/initTransaction`, { aplCatl }, {
        ...options,
        closeAlert: true,
    });
}

export function getResult() {
    return get(`${url}/transactionResult`);
}

export function getPeriod() {
    return get(`${url}/reservePeriod/getPeriod`);
}

export function postPeriod(data) {
    return post(`${url}/reservePeriod/submitPeriod`, data, {
        ...options,
        repeatRequestCancel: true,
    });
}

export function showReserverList() {
    return get(`${url}/showReserveList`);
}

export function getLoanAgreeTerms() {
    return get(`${loanUrl}/getAgreeTerms`);
}

export function getLoanPolicyInfo() {
    return get(`${loanUrl}/info`);
}

export function postLoanAgreeTerms(data) {
    return post(`${loanUrl}/agree`, data, {
        ...options,
        repeatRequestCancel: true,
    });
}

export function postLoanSubmit(data) {
    return post(`${loanUrl}/submit`, data, {
        ...options,
        repeatRequestCancel: true,
    });
}

export function getLoanContactInfo() {
    return get(`${loanUrl}/contactInfo`);
}

export function postLoanSubmitContact(data) {
    return post(`${loanUrl}/submitContact`, data, { ...options, repeatRequestCancel: true });
}
